import React from 'react';
import { CheckIcon, TargetIcon } from 'lucide-react';
import { volumes, images } from '../data/content';
import { SectionHeading } from './SectionHeading';
import { CtaButton } from './CtaButton';
export function Volumes() {
  return <section className="bg-cream py-16 sm:py-24" data-id="element-389" data-mp="185ga1ylxnoli">
      <div className="mx-auto max-w-6xl px-4" data-id="element-390" data-mp="1c4yxp2552ds1">
        <SectionHeading eyebrow="What’s Inside Third Molar Assessment Blueprint™?" title="6 Premium Volumes to Help You Organize the Major Areas of Third Molar Assessment" intro="Each volume focuses on a different part of the assessment process, creating one integrated visual reference system." data-id="element-391" data-mp="1c60c9gld5iei" />

        <img src={images.mockup} alt="Third Molar Assessment Blueprint™ six-volume collection" className="-mx-4 mt-8 w-[calc(100%+2rem)] max-w-none sm:mx-auto sm:w-full sm:max-w-2xl" data-id="element-392" data-mp="1vtg16zn5ph0m" />

        <div className="mt-8 space-y-6" data-id="element-393" data-mp="kekovkbzfrn8">
          {volumes.map(v => <article key={v.numeral} className="grid gap-6 rounded-3xl bg-white p-6 shadow-[0_10px_40px_-25px_rgba(16,42,76,0.35)] sm:p-8 lg:grid-cols-[1fr_1.1fr] lg:gap-10" data-id="element-394" data-mp="3o86jo4d1je4w">
              <div data-id="element-395" data-mp="21hvggjy5rlu">
                <p className="inline-flex rounded-md bg-navy px-2.5 py-1 text-xs font-extrabold uppercase tracking-wider text-white" data-id="element-396" data-mp="2201g4wevk6y">
                  Volume {v.numeral}
                </p>
                <h3 className="mt-3 font-display text-2xl font-bold leading-tight text-ink sm:text-3xl" data-id="element-397" data-mp="b0lczg3gtyy8">{v.title}</h3>
                <p className="mt-2 text-base font-semibold text-accent" data-id="element-398" data-mp="620ogdxkt3pm">{v.subtitle}</p>
                <div className="mt-4 space-y-3 text-[15px] leading-relaxed text-ink/80" data-id="element-399" data-mp="kqeraouzss66">
                  {v.intro.map(p => <p key={p} data-id="element-400" data-mp="fug5n911to9g">{p}</p>)}
                </div>
                <div className="mt-5 flex items-start gap-3 rounded-2xl bg-accentSoft p-4" data-id="element-401" data-mp="tsnxj2j89zdr">
                  <TargetIcon className="mt-0.5 h-5 w-5 shrink-0 text-accent" aria-hidden="true" data-id="element-402" data-mp="pru824q50cir" />
                  <p className="text-[15px] leading-relaxed text-ink" data-id="element-403" data-mp="wv24qshyg0n7">
                    <strong data-id="element-404" data-mp="11sanovaxg8pi">The goal:</strong> {v.goal}
                  </p>
                </div>
              </div>

              <div className="lg:border-l lg:border-line lg:pl-10" data-id="element-405" data-mp="16qvqn2hkd6hn">
                <p className="text-xs font-bold uppercase tracking-[0.14em] text-muted" data-id="element-406" data-mp="1bidk75h9c4sl">Inside, you’ll find</p>
                <ul className="mt-3 space-y-2.5" data-id="element-407" data-mp="1fkqpxtw082pd">
                  {v.items.map(item => <li key={item} className="flex items-start gap-3 text-[15px] leading-relaxed text-ink" data-id="element-408" data-mp="1kiseuvg42w8r">
                      <CheckIcon className="mt-0.5 h-5 w-5 shrink-0 text-cta" aria-hidden="true" data-id="element-409" data-mp="1pi53nlqjmddz" />
                      {item}
                    </li>)}
                </ul>
                {v.note && <p className="mt-5 border-t border-line pt-4 text-xs leading-relaxed text-muted" data-id="element-410" data-mp="3rat9m2uknexg">{v.note}</p>}
              </div>
            </article>)}
        </div>

        <div className="mt-10" data-id="element-411" data-mp="2ddhyh3510d6d">
          <CtaButton label="I Want All 6 Premium Volumes" data-id="element-412" data-mp="2dejkg2nkyk2v" />
        </div>
      </div>
    </section>;
}